import PropTypes from 'prop-types'
import { createContext, useState, useEffect, useRef } from 'react'
import { toastErrorLog } from '../../helpers/toastErrorLog'
import { useAuth } from '../../hooks/useAuth'
import * as menusService from '../servicios/menusService'

export const MenuContext = createContext()
MenuContext.displayName = 'MenuContext'

export const MenuProvider = (props) => {
  const [menus, setMenus] = useState([])
  const [menuAbierto, desplegarMenu] = useState(false)
  const nav = useRef(null)
  const { loginDataContext: { idUsuario } = {}, cargandoUsuario } = useAuth()

  useEffect(() => {
    if (!idUsuario || cargandoUsuario) return

    let activo = true

    const obtenerMenus = async () => {
      try {
        const { data: menus } = await menusService.buscarTodos('', idUsuario)
        if (activo) setMenus(menus)
      } catch (error) {
        if (!activo) return
        toastErrorLog(error, 'Error al cargar los menus', 'menus')
        setMenus([])
      }
    }

    obtenerMenus()

    return () => {
      activo = false
    }
  }, [idUsuario, cargandoUsuario])

  useEffect(() => {
    if (nav.current) {
      // Toggle the minify class based on menu state
      if (menuAbierto) {
        nav.current.classList.remove('vertical_nav__minify')
      } else {
        nav.current.classList.add('vertical_nav__minify')
      }
    }
  }, [menuAbierto])

  return (
    <MenuContext.Provider value={{ menus, desplegarMenu, menuAbierto, nav }}>
      {props.children}
    </MenuContext.Provider>
  )
}

MenuProvider.propTypes = {
  children: PropTypes.node.isRequired
}
